module.exports = __webpack_public_path__ + "img/openai-account-banned-for-policy-violations.f4a05b55.jpeg";